<template>
    <div class="cheatManage">

        <div class="breadcrumb">作弊管理
            <el-button class="right_f" type="primary" @click="save">导出</el-button>
        </div>

        <div class="selectSchool">
            <el-select class="selectInput" v-model="region" filterable clearable placeholder="请选择校区">
                <el-option v-for="item in option" :key="item.unid" :label="item.name" :value="item.unid">
                </el-option>
            </el-select>
        </div>
        <div class="formdata">
            <el-form ref="cheatForm" :rules="rules" :model="cheatForm">
                <el-form-item prop="startTime" class="time">
                    <el-date-picker v-model="cheatForm.startTime" format="yyyy/MM/dd" placeholder="请选择开始时间" class="qizhiDate"></el-date-picker>
                </el-form-item>
                &nbsp;&nbsp;至&nbsp;&nbsp;
                <el-form-item prop="endTime" class="time">
                    <el-date-picker v-model="cheatForm.endTime" class="qizhiDate" format="yyyy/MM/dd" placeholder="请选择结束时间"></el-date-picker>
                </el-form-item>
                <div>
                    同一设备一天内登录
                    <el-form-item prop="number" class="number">
                        <el-input v-model="cheatForm.number" type='number'></el-input>
                    </el-form-item>
                    个账户，认为有作弊嫌疑！
                </div>
            </el-form>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                region: '',
                option: [],
                cheatForm: {
                    startTime: '',
                    endTime: '',
                    number: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入校区名称', trigger: 'blur' }
                    ],
                    startTime: [
                        { type: 'date', required: true, message: '请填写开始时间', trigger: 'change' }
                    ],
                    endTime: [
                        { type: 'date', required: true, message: '请填写结束时间', trigger: 'change' }
                    ],
                    number: [
                        { type: 'number', min: 2, required: true, message: '请填写作弊账户登录下限', trigger: 'change' }
                    ]
                }
            }
        },
        mounted() {
            this.getallcampus();
        },
        methods: {
            // 获取所有校区
            getallcampus() {
                this.$http({
                    method: 'get',
                    url: this.$util.domain + '/adminapi/v1/basicTools/allCampusZones',
                }).then(response => {
                    if (response.data.error == 10000) {
                        this.option = response.data.data;
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                })
            },
            // 保存
            save() {

                this.$refs.cheatForm.validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        console.log('error submit');
                    }
                })
            },
            submit() {
                let startTime = new Date(this.cheatForm.startTime).format("yyyy-MM-dd");
                let startTime1 = new Date(startTime);
                let endTime = new Date(this.cheatForm.endTime).format("yyyy-MM-dd");
                let endTime1 = new Date(endTime);
                if (startTime1.getTime() > endTime1.getTime()) {
                    this.$util.errorMsg("请选择正确的日期，且结束日期不得早于开始日期");
                    return;
                }
                let params = {
                    unid: this.region,
                    startDate: startTime,
                    endDate: endTime,
                    num: this.cheatForm.number
                }
                this.$util.refreshTo(`${this.$util.domain}/adminapi/v1/campus/cheat/userLog`, params);
            }
        }

    }
</script>
<style>
    .cheatManage .formdata {
        margin-left: 20px;
        margin-bottom: 20px;
    }

    .cheatManage .selectInput {
        width: 40%;
    }

    .cheatManage .time {
        display: inline-block;
        width: 18%;
    }

    .cheatManage .qizhiDate {
        display: inline-block;
    }

    .cheatManage .number {
        width: 12%;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// cheatManage.vue?5413b2f2